import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyFeatureService,
  Wealthlane_AppServices_Features_CompanyFeatureSetDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetFeaturePermissionSet = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AppServices_Features_CompanyFeatureSetDto> | undefined,
  unknown
> => {
  const getFeaturePermissionSet = useQuery(['getFeaturePermissionSet'], async () => {
    return await handleRequest(CompanyFeatureService.getApiIdentityCompanyFeaturePermissions(''));
  }, { enabled });

  return getFeaturePermissionSet;
};

export default useGetFeaturePermissionSet;
